import React, { useEffect, useState } from "react";
import { Row, Button, Label } from "reactstrap";
import { formatDateFromString } from "../../../Utils/externalFunctions";
import DataTable from "react-data-table-component";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import { Download, Info, Trash2 } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import {
  APISentSuccessMsg,
  getItemDeleteSuccessMsg,
} from "../../../Constant/Message";
import { toast } from "react-toastify";
import useAxios from "../../../Utils/useAxios";
import { timeToast } from "../../../Constant";
import DATA_TYPE from "../../../Constant/DataType";
import RincianTandaTerimaModal from "../components/RincianTandaTerimaModal";
import FilterComponent from "../../FilterComponents/FilterComponent";
import { filterSearch } from "../../../Utils/FilterItems";
import { useThemeContext } from "../../../Context/ThemeContext";
import DateSortFunction from "../../DataTableComponents/DateSortFunction";
import ConfirmRemovalModal from "../components/ConfirmRemovalModal";
toast.configure();

const StepSatu = ({
  handleRadio,
  selectedGroupTransaksi,
  groupTransaksiList,
  transaksiList,
  pending,
  handleNext,
}) => {
  const navigate = useNavigate();
  const axiosInstance = useAxios();
  const [selectedTransaksiList, setSelectedTransaksiList] = useState(null);
  const [isButtonActive, setIsButtonActive] = useState(false);
  const [groupInfoModalOpen, setGroupInfoModalOpen] = useState(false);
  const toggleGroupInfoModal = () => setGroupInfoModalOpen(!groupInfoModalOpen);
  const [deleteGroupModalOpen, setDeleteGroupModalOpen] = useState(false);
  const toggleDeleteGroupModal = () =>
    setDeleteGroupModalOpen(!deleteGroupModalOpen);

  const [filteredGroupTransaksi, setFilteredGroupTransaksi] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const { themeContext } = useThemeContext();

  useEffect(() => {
    setIsButtonActive(selectedGroupTransaksi !== undefined);
  }, [selectedGroupTransaksi]);

  const handleDeleteGroup = async (row) => {
    try {
      const response = await axiosInstance.delete(
        `groupdokumentransaksi/${row.id}`
      );
      if (response.status === 204) {
        console.log(APISentSuccessMsg);
        toast.success(getItemDeleteSuccessMsg(DATA_TYPE.GrupTransaksi), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: timeToast,
        });
        navigate(`${process.env.PUBLIC_URL}/transaksi/susulangroup`);
      }
    } catch (e) {
      console.log(e);
      toast.error(e.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    }
  };

  useEffect(() => {
    updateFilter(groupTransaksiList);
  }, [groupTransaksiList, filterText]);

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const updateFilter = (items) => {
    const searchCategories = [
      "kode_group_dokumen",
      "diajukan_oleh",
      "username_pic_keuangan",
    ];
    const filteredItems = items.filter(
      filterSearch(searchCategories, filterText)
    );

    setFilteredGroupTransaksi(filteredItems);
  };

  const DaftarColumns = [
    {
      name: <DataTableTitle text={"Tanggal"} />,
      selector: (row) => formatDateFromString(row.tgl),
      sortable: true,
      sortFunction: DateSortFunction("tgl", "string"),
    },
    {
      name: <DataTableTitle text={"Kode"} />,
      selector: (row) => row.kode_group_dokumen,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Diajukan Oleh"} />,
      selector: (row) => row.diajukan_oleh,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"PIC Keuangan"} />,
      selector: (row) => row.username_pic_keuangan,
      sortable: true,
    },
    // {
    //   name: <DataTableTitle text={"Status"} />,
    //   selector: (row) => row.id_status_dokumen,
    //   sortable: true,
    // },
    {
      name: <DataTableTitle text={"Operasi"} />,
      cell: (row) => (
        <Row className="justify-content-between mt-2">
          <Link
            className="col-auto"
            onClick={(e) => {
              e.preventDefault();
              setSelectedTransaksiList(row);
              toggleGroupInfoModal();
            }}
          >
            <Info />
          </Link>
          <Link
            className="col-auto"
            to={`${process.env.PUBLIC_URL}/groupdokumentransaksi/document/${row.id}`}
            target="_blank"
          >
            <Download />
          </Link>
          <Link
            className="col-auto"
            onClick={(e) => {
              e.preventDefault();
              setSelectedTransaksiList(row);
              toggleDeleteGroupModal();
            }}
          >
            <Trash2 color="red" />
          </Link>
        </Row>
      ),
    },
  ];

  return (
    <>
      <Label className="bg-transparent">Grup Transaksi yang tersedia</Label>
      <DataTable
        columns={DaftarColumns}
        data={filteredGroupTransaksi}
        pagination
        subHeader
        subHeaderComponent={
          <FilterComponent
            onFilter={(e) => {
              setFilterText(e.target.value);
            }}
            onClear={() => handleClear()}
            filterText={filterText}
          />
        }
        subHeaderAlign="right"
        selectableRowsHighlight
        selectableRows
        // selectableRowsRadio="radio"
        selectableRowsSingle
        onSelectedRowsChange={handleRadio}
        highlightOnHover
        progressPending={pending}
        persistTableHead
        theme={themeContext}
      />
      <div className="row justify-content-end mt-4">
        <div className="col-auto">
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              if (selectedGroupTransaksi !== null) {
                handleNext();
              } else {
                toast.error("Pilih group transaksi sebelum melanjutkan", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: timeToast,
                });
              }
            }}
            disabled={!isButtonActive}
          >
            Selanjutnya
          </Button>
        </div>
      </div>
      {selectedTransaksiList && (
        <RincianTandaTerimaModal
          axiosInstance={axiosInstance}
          selectedTandaTerima={selectedTransaksiList}
          modalOpen={groupInfoModalOpen}
          toggleModal={toggleGroupInfoModal}
        />
      )}
      {transaksiList && (
        <ConfirmRemovalModal
          label={"Anda yakin ingin menghapus group transaksi ini?"}
          isOpen={deleteGroupModalOpen}
          toggle={toggleDeleteGroupModal}
          handleDelete={handleDeleteGroup}
          row={selectedTransaksiList}
        />
      )}
    </>
  );
};

export default StepSatu;
